import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-down-dir",
  "use": "icon-down-dir-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-down-dir\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-down-dir</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-down-dir_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-down-dir_icon-down-dir\">\n            <path d=\"M15.7091667,7.5 C15.7091667,7.6866676 15.6425007,7.8533326 15.5091667,8 L10.5091667,13 C10.3624993,13.1466674 10.1958343,13.22 10.0091667,13.22 C9.82249905,13.22 9.65583405,13.1466674 9.50916665,13 L4.50916665,8 C4.36249925,7.8533326 4.28916665,7.6866676 4.28916665,7.5 C4.28916665,7.3133324 4.36249925,7.1466674 4.50916665,7 C4.65583405,6.8533326 4.82249905,6.78 5.00916665,6.78 L15.0091667,6.78 C15.1958343,6.78 15.3624993,6.8533326 15.5091667,7 C15.6558341,7.1466674 15.7225001,7.3133324 15.7091667,7.5 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sprites/icon-down-dir.svg
// module id = ABrP
// module chunks = 1